import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const appInsights = process.env.NODE_ENV !== 'test'
  ? new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_AZURE_APP_INSIGHTS_KEY || '',
    },
  })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();
}

const logger = {
  log: (message, data = {}) => {
    console.log(message, data);
    if (appInsights) {
      appInsights.trackTrace({ message, properties: data });
    }
  },

  error: (message, error = {}) => {
    console.error(message, error);
    if (appInsights) {
      appInsights.trackException({ exception: error, properties: { message } });
    }
  },

  event: (eventName, properties = {}) => {
    if (appInsights) {
      appInsights.trackEvent({ name: eventName, properties });
    }
  },
};

export default logger;
